import React, { useEffect, useState, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";

import CrossIcon from "../assets/icons/cross.svg";
import MenuIcon from "../assets/icons/menu.svg";
import { EMAIL } from "./contact";

import "./styles.css";

const MOBILE_QUERY = "(max-width: 768px)";

export default function Header() {
	const [menuOpen, setMenuOpen] = useState(false);
	const [mobileActive, setMobileActive] = useState(
		() => window.matchMedia(MOBILE_QUERY).matches
	);
	const location = useLocation();
	const navRef = useRef();

	useEffect(() => {
		const query = window.matchMedia(MOBILE_QUERY);
		const handleChange = () => {
			setMobileActive(query.matches);
			if (!query.matches) setMenuOpen(false);
		};
		query.addEventListener("change", handleChange);
		return () => query.removeEventListener("change", handleChange);
	}, []);

	// Close the menu on navigation, outside clicks and Escape.
	useEffect(() => setMenuOpen(false), [location.pathname]);

	useEffect(() => {
		if (!menuOpen) return;

		function handleClickOutside(event) {
			if (navRef.current && !navRef.current.contains(event.target)) {
				setMenuOpen(false);
			}
		}
		function handleKeyDown(event) {
			if (event.key === "Escape") setMenuOpen(false);
		}

		document.addEventListener("mousedown", handleClickOutside);
		document.addEventListener("keydown", handleKeyDown);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
			document.removeEventListener("keydown", handleKeyDown);
		};
	}, [menuOpen]);

	const scrollTopIfCurrent = (route) => {
		if (route === location.pathname) {
			window.scrollTo({ top: 0, behavior: "smooth" });
		}
	};

	return (
		<nav aria-label="Main" ref={navRef}>
			<a className="skip-link" href="#main-content">
				Skip to content
			</a>
			<div className="topbar">
				<NavLink
					to={"/"}
					onClick={() => scrollTopIfCurrent("/")}
					className="logo"
					aria-label="mmunaf, home"
				>
					mmunaf
				</NavLink>

				{mobileActive && (
					<button
						type="button"
						className="menu-toggle"
						aria-expanded={menuOpen}
						aria-controls="nav-menu"
						aria-label={menuOpen ? "Close menu" : "Open menu"}
						onClick={() => setMenuOpen(!menuOpen)}
					>
						<img src={menuOpen ? CrossIcon : MenuIcon} alt="" />
					</button>
				)}

				{(!mobileActive || menuOpen) && (
					<ul
						id="nav-menu"
						className={
							mobileActive ? "nav-items-mobile" : "nav-items-desktop"
						}
					>
						<li>
							<NavLink to={"/work"} onClick={() => scrollTopIfCurrent("/work")}>
								Work
							</NavLink>
						</li>
						<li>
							<NavLink to={"/about"} onClick={() => scrollTopIfCurrent("/about")}>
								About
							</NavLink>
						</li>
						<li>
							<a href={`mailto:${EMAIL}`} className="fancy-email">
								Say hello
								<span className="visually-hidden"> by email</span>
							</a>
						</li>
					</ul>
				)}
			</div>
		</nav>
	);
}
